(() => {
  'use strict';
  const initialized = new WeakSet();
  const formatSelector = '[name="properties[Format]"], [name="preview-format"]';

  function formatField(scope) { return scope.querySelector(formatSelector); }
  function formatChoices(scope, field) {
    return field && field.type === 'radio' ? Array.from(scope.querySelectorAll(formatSelector)) : Array.from(field && field.options || []);
  }
  function formatValue(scope, field) {
    if (!field) return '';
    if (field.type !== 'radio') return field.value;
    const selected = formatChoices(scope, field).find((choice) => choice.checked && !choice.disabled);
    return selected ? selected.value : '';
  }
  function allowedFormat(scope, field, value) {
    return !!field && typeof value === 'string' && value !== '' && formatChoices(scope, field).some((choice) => !choice.disabled && choice.value === value);
  }
  function setFormat(scope, field, value) {
    if (field.type === 'radio') {
      formatChoices(scope, field).forEach((choice) => { choice.checked = !choice.disabled && choice.value === value; });
    } else {
      field.value = value;
    }
  }
  function storageKey(scope) {
    const variant = scope.querySelector('[name="id"]');
    if (variant && /^\d+$/.test(variant.value)) return 'nuitigo:selection:v1:variant:' + variant.value;
    // Private previews have no sellable variant. Keep their choices separate.
    return 'nuitigo:selection:v1:preview:' + window.location.pathname + ':' + (scope.id || 'product');
  }
  function restore(scope) {
    const quantity = scope.querySelector('[name="quantity"]');
    const format = formatField(scope);
    if (!quantity) return;
    // Browser history/autofill and any choice already made take precedence.
    if (formatValue(scope, format) !== '' || quantity.value !== quantity.defaultValue || document.activeElement === format || document.activeElement === quantity || (format && format.type === 'radio' && formatChoices(scope, format).includes(document.activeElement))) return;
    try {
      const saved = JSON.parse(window.sessionStorage.getItem(storageKey(scope)) || 'null');
      if (!saved || !Number.isSafeInteger(saved.quantity) || saved.quantity < 1 || saved.quantity > 999) return;
      if (format && !allowedFormat(scope, format, saved.format)) return;
      if (format) setFormat(scope, format, saved.format);
      quantity.value = String(saved.quantity);
    } catch (_) { /* Storage can be unavailable in private/restricted browsing. */ }
  }
  function save(scope) {
    const quantity = scope.querySelector('[name="quantity"]');
    const format = formatField(scope);
    if (!quantity || quantity.value.trim() === '') return;
    const count = Number(quantity.value);
    if (!Number.isSafeInteger(count) || count < 1 || count > 999 || (format && !allowedFormat(scope, format, formatValue(scope, format)))) return;
    try {
      // Only product choices are retained, for this tab's session.
      window.sessionStorage.setItem(storageKey(scope), JSON.stringify({ format: formatValue(scope, format), quantity: count }));
    } catch (_) { /* Buying and the visible summary never depend on storage. */ }
  }
  function update(scope) {
    const quantity = scope.querySelector('[name="quantity"]');
    const output = scope.querySelector('[data-selection-summary]');
    if (!quantity || !output) return;
    const picker = scope.querySelector('[data-variant-picker]');
    const option = picker && picker.selectedOptions[0];
    const unitPrice = Number(option ? option.dataset.priceCents : scope.dataset.unitPrice);
    const count = Number(quantity.value);
    const valid = quantity.value.trim() !== '' && Number.isSafeInteger(count) && count > 0 && Number.isSafeInteger(unitPrice) && unitPrice >= 0 && Number.isSafeInteger(unitPrice * count);
    output.dataset.invalid = String(!valid);
    if (!valid) {
      output.textContent = 'Choisissez une quantité entière à partir de 1.';
      output.hidden = false;
      return;
    }
    const format = formatField(scope);
    const selectedFormat = format && allowedFormat(scope, format, formatValue(scope, format)) ? formatValue(scope, format) : '';
    if (count === 1 && !selectedFormat) {
      output.textContent = '';
      output.hidden = true;
      return;
    }
    const currency = scope.dataset.currency || 'EUR';
    let amount;
    try { amount = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency }).format(unitPrice * count / 100); }
    catch (_) { amount = (unitPrice * count / 100).toFixed(2).replace('.', ',') + ' ' + currency; }
    const total = count + (count === 1 ? ' rideau · ' : ' rideaux · ') + amount + ' TTC';
    if (selectedFormat) {
      const dimensions = selectedFormat.match(/^(\d+)\s*×\s*(\d+)\s*cm$/u);
      const label = dimensions ? 'Largeur ' + dimensions[1] + ' cm · hauteur ' + dimensions[2] + ' cm' : selectedFormat;
      output.replaceChildren(document.createTextNode(label), document.createElement('br'), document.createTextNode(total));
    } else {
      output.textContent = total;
    }
    output.hidden = false;
  }
  function initialize(scope) {
    if (!initialized.has(scope)) {
      restore(scope);
      initialized.add(scope);
    }
    update(scope);
  }
  function updateAll() { document.querySelectorAll('[data-purchase-summary]').forEach(initialize); }
  ['input', 'change'].forEach((name) => document.addEventListener(name, (event) => {
    const scope = event.target.closest('[data-purchase-summary]');
    if (scope) { initialize(scope); save(scope); }
  }));
  document.addEventListener('shopify:section:load', updateAll);
  window.addEventListener('pageshow', updateAll);
  updateAll();
})();
